import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from './MaterialSymbol';

const CloseIconStyled = styled(MaterialSymbol)`
  cursor: pointer;
  vertical-align: middle;
  color: var(--secondary);
  &:hover {
    color: var(--secondaryHover);
  }
`;

type Props = {
  onClick?: () => void;
};

export default function RemoveIcon({ onClick }: Props) {
  return <CloseIconStyled icon="close" onClick={onClick} />;
}
